import { useEffect, useRef } from 'react';
import type { IScreensLogging } from '../../../../../api/types';
import { bridge } from '../../../../../utils';

export const useLogDisplayCarousel = (
  logging?: IScreensLogging,
  isVisible?: boolean,
) => {
  const logged = useRef(false);

  useEffect(() => {
    if (logged.current || !isVisible || !logging?.analytics) {
      return;
    }
    logged.current = true;

    bridge.logAnalyticsEvent({
      name: 'DISPLAY_CAROUSEL',
      analytics: logging.analytics,
      ably_only_log: logging.ably_only_log,
    });
  }, [isVisible, logging]);
};
